import React, { useState, useEffect } from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import MenuItem from '@mui/material/MenuItem';
import { InputAdornment } from '@mui/material';
import { getLocalNumberLength, getPartner, getPartnerGuid } from '../../../../../lib/access.es6';
import { BankData } from '../../../lib/AccessBankBranches';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { agentsData } from '../../../CustomerStatus/Containers/RegisterCustomer/Components/AgentDataPlaceholder';
import {
  PARTNERS_WITH_EXTENDED_CLAIMANT_RELATIONSHIPS,
  PARTNERS_WITHOUT_CLAIM_AGENT_CAPTURE
} from '../../../../../routes/PartnersEnum';

const BASE_CLAIMANT_RELATIONSHIPS = ['Self', 'Spouse', 'Son', 'Daughter'];
const EXTENDED_CLAIMANT_RELATIONSHIPS = [
  'Self', 'Spouse', 'Child', 'Son', 'Daughter', 'Parent', 'Parent_In_Law', 'Sibling', 'Other'
];

const getDependantFullName = (dependant) => {
  return [dependant.first_name, dependant.middle_name, dependant.last_name]
    .filter(Boolean)
    .join(' ');
};

const ClaimLoggingDetails = (props) => {
  const classes = useStyle();

  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [idNumber, setIdNumber] = useState('');
  const [relationship, setRelationship] = useState(null)
  const [member, setMember] = useState('');

  const [selectedAgent, setSelectedAgent] = useState(null);
  const [selectedAgentError, setSelectedAgentError] = useState(false)
  const [agentDataPlaceHolder, setAgentPlaceholder] = useState([]);


  const [openBranches, setOpenBranches] = useState(false);
  const [inputBranchValue, setInputBranchValue] = useState('');

  const [selectedBranchError, setSelectedBranchError] = useState(false);

  const members = props.eventQuote.policy_schedule_entries ? props.eventQuote.policy_schedule_entries : []

  useEffect(() => {

    ValidatorForm.addValidationRule('isValidPhoneNumber', value => {
      return value.length === getLocalNumberLength();
    });

    return function cleanup() {
      ValidatorForm.removeValidationRule('isValidPhoneNumber');
    };
  }, [])

  useEffect(() => {

    if (props.agentUsersData.length === 0) {
      setAgentPlaceholder(
        agentsData
      )
    }

  }, [])


  const handleBranchInputChange = (event, newValue) => {
    setSelectedBranchError(!newValue)
    setInputBranchValue(newValue);
    props.setAdditionalState('agent_branch', newValue)
  };

  const internationalCallingCode = getPartner().country.international_calling_code

  // international_calling_code already carries the "00" IDD prefix (e.g. "00256"),
  // matching the msisdn shape the auto-filled numbers are sliced from.
  const idd = (internationalCallingCode || '').toString().replace(/[^0-9]/g, '')

  // A relationship auto-filled off the policy member (Child, Parent_In_Law, ...) has to
  // stay in the option list or the Select renders blank.
  const getRelationshipOptions = () => {
    const options = PARTNERS_WITH_EXTENDED_CLAIMANT_RELATIONSHIPS.includes(getPartnerGuid())
      ? EXTENDED_CLAIMANT_RELATIONSHIPS
      : BASE_CLAIMANT_RELATIONSHIPS;

    return relationship && options.indexOf(relationship) === -1
      ? options.concat([relationship])
      : options;
  }

  // const parnterGuid = getPartnerGuid();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4>Claimant details?</h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => { }}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>

          <Grid item xs={12}>
            <SelectValidator
              labelId="select-member"
              id="select-member"
              value={member}
              name='selectmember'
              type="text"
              label="Select from policy member"
              onChange={(e) => {

                const fullPhoneNumber = e.target.value.dependant.msisdn
                const n = getDependantFullName(e.target.value.dependant)
                const i = e.target.value.dependant.national_id;
                const r = e.target.value.dependant.relationship === 'Principal' ? 'Self' : e.target.value.dependant.relationship

                setMember(e.target.value)
                setName(n)
                setIdNumber(e.target.value.dependant.national_id)

                props.setAdditionalState('claimant_full_name', n)


                const nineDigit = fullPhoneNumber ? fullPhoneNumber.substring(5, fullPhoneNumber.length) : ''

                props.setAdditionalState('claimant_phone_number', nineDigit)
                setPhoneNumber(nineDigit)

                props.setAdditionalState('claimant_id_number', i)
                props.setAdditionalState('claimant_relationship_to_patient', r)
                setRelationship(r)
              }}

              variant="outlined"
              validators={['required']}
              errorMessages={['Please select a member']}
              style={{ width: "100%" }}
              sx={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.005em",
                color: "#000000",
              }}
            >

              {
                members.map((entry, index) => (
                  <MenuItem
                    key={index}
                    sx={{
                      fontFamily: "Open Sans",
                      fontStyle: "normal",
                      fontWeight: 300,
                      fontSize: "12px",
                      lineHeight: "16px",
                      letterSpacing: "0.005em",
                      color: "#000000",
                    }}
                    value={entry}>{entry.dependant.first_name + " " + entry.dependant.last_name}</MenuItem>
                ))
              }

            </SelectValidator>
            <hr />

          </Grid>


          <Grid item xs={12} md={6} sm={6}>
            <TextValidator
              id="name"
              style={{ width: "100%" }}
              label="Full Names"
              name='name'
              value={name}
              onChange={(e) => {
                setName(e.target.value)
                props.setAdditionalState('claimant_full_name', e.target.value)
              }}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please enter you full names']}
            />
          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <TextValidator
              id="phone"
              style={{ width: "100%" }}
              label="Phone"
              name='phone'
              value={phoneNumber}
              onChange={(e) => {
                setPhoneNumber(e.target.value)
                props.setAdditionalState('claimant_phone_number', idd + e.target.value)
              }}
              InputProps={{
                startAdornment: <InputAdornment
                  sx={{
                    fontSize: "small",
                    color: "#000",
                    background: "#F7F7F7"
                  }}
                  position="start"
                > <span style={{
                  fontSize: "small",
                  color: "#000"
                }}>{internationalCallingCode ? internationalCallingCode : ''}</span></InputAdornment>,

              }}
              variant="outlined"
              validators={["isValidPhoneNumber"]}
              errorMessages={[`Please enter a valid ${getLocalNumberLength()} digit phone number`]}
            />
          </Grid>

          <Grid item xs={12} md={6} sm={6}>
            <TextValidator
              id="id"
              style={{ width: "100%" }}
              label="Id number"
              name='id'
              value={idNumber}
              onChange={(e) => {
                setIdNumber(e.target.value)
                props.setAdditionalState('claimant_id_number', e.target.value)

              }}
              variant="outlined"
              validators={['required']}
              errorMessages={['Please enter you id number']}
            />
          </Grid>

          <Grid item xs={12} md={6} sm={6}>

            <SelectValidator
              labelId="select-relationship"
              id="select-relationship"
              value={relationship}
              label="Relationship"
              name='relationships'
              onChange={(event) => {
                setRelationship(event.target.value)
                props.setAdditionalState('claimant_relationship_to_patient', event.target.value)
              }}
              style={{ width: "100%" }}
              sx={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "0.005em",
                color: "#000000",
              }}
              variant="outlined"
              InputLabelProps={{
                shrink: !!relationship,
              }}
            >
              {
                getRelationshipOptions().map((option, index) => {
                  return <MenuItem
                    key={index}
                    sx={{
                      fontFamily: "Open Sans",
                      fontStyle: "normal",
                      fontWeight: 300,
                      fontSize: "12px",
                      lineHeight: "16px",
                      letterSpacing: "0.005em",
                      color: "#000000",
                    }}
                    value={option}>
                    {option.split('_').join(' ')}</MenuItem>
                })
              }
            </SelectValidator>
          </Grid>

        </Grid>
        {
          PARTNERS_WITHOUT_CLAIM_AGENT_CAPTURE.includes(getPartnerGuid()) ? (<></>) : (<>
               <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.headingclaim}>
              <h4>Agent details?</h4>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} sm={6}>

            <Autocomplete
              options={props.agentUsersData.length > 0 ? props.agentUsersData : agentDataPlaceHolder}
              getOptionLabel={(user) => `${user.firstName} ${user.lastName}`}
              getOptionSelected={(option, value) => option.id === value.id}
              onChange={(event, value) => {
                console.log(value)
                props.setAdditionalState('agent_email', value.email)
                setSelectedAgent(value);
                setSelectedAgentError(!value)
              }}
              value={selectedAgent}
              renderInput={(params) => (
                <TextField {...params}
                  style={{ width: "100%" }}
                  label="Select Agent"
                  variant="outlined"
                  error={selectedAgentError}
                  helperText={selectedAgentError ? 'Please select an agent' : ''}
                />
              )}
            />


          </Grid>
          <Grid item xs={12} md={6} sm={6}>
            <Autocomplete
              style={{ width: "100%" }}
              open={openBranches}
              onOpen={() => {
                setOpenBranches(true);
              }}
              onClose={() => {
                setOpenBranches(false);
              }}
              ListboxProps={{
                sx: {
                  "& li": {
                    fontFamily: 'Open Sans',
                    fontStyle: "normal",
                    fontSize: "12px",
                    lineHeight: "25px",
                    color: "#000000",
                  },
                }
              }}
              id="branch"
              name='branch'
              options={BankData}
              //getOptionLabel={(option) => `${option.name} (${BankData.find(bank => bank.branch_details.includes(option)).bank_name})`}
              inputValue={inputBranchValue}
              onInputChange={handleBranchInputChange}
              renderInput={(params) => (
                <TextField
                  style={{ width: "100%" }}
                  {...params}
                  label="Select Branch"
                  variant="outlined"
                  error={selectedBranchError}
                  helperText={selectedBranchError ? 'Please select a branch' : ''}
                />
              )}
            />
          </Grid>
        </Grid>
          
          </>)
        }

   
      </ValidatorForm>
    </>
  )
}

export default ClaimLoggingDetails